export const CollabEntityType = {
	tasks: 'tasks',
	files: 'files',
	calendar: 'calendar',
};
